/**
 * @ngdoc controller
 * @name loginFormController
 * @description Reset Password, Login and Forgot password controller.
 * @param User
 * @constructor
 */
export default function loginFormController(User, $state, Alerts, $previousState) {
  'ngInject';

  /**
   * @name login
   * @description Takes a username and password, calling the User authentication service to create a session,
   * On success we change state to the / state or the variable next state brought in by the login form directive.
   * On error, a message will be displayed and the view will change to open the rest password form.
   */
  this.login = () => {
    if (this.loginForm.$valid) {
      User.authenticate(this.username, this.password).then(
        //Success
        ()=> {

          if (this.next) {
            $state.go(this.next, {}, {reload: true});
          }
          else {
            let prev = $previousState.get();
            if(prev) {
              let {state, params} = prev;
              $state.go(state, params, {reload: true});
            }else{
              $state.go('app', {}, {reload: true});
            }

          }
        },
        //No Success
        ()=> {
          Alerts.add({
            type: 'reset-password',
            template: 'app/components/loginForm/resetAlert.html'
          });
        });
    }
  };

  /**
   * @name reset
   * @description Call user service to reset password for username/email.
   * Response fills in a message element on the template with the appropriate message.
   */
  this.reset = () => {
    if (this.resetForm.$valid) {
      User.resetPassword(this.username).then(
        ()=> {
          Alerts.add({
            type: 'success',
            message: `We have successfully sent you an email to reset your password.`
          });
          this.complete = true;
        },
        (error)=> {
          Alerts.add({
            type: 'warning',
            message: error
          });
        });
    }
  };

}



/** WEBPACK FOOTER **
 ** ./src/app/components/loginForm/loginForm.controller.js
 **/